
<nz-segmented style="margin-bottom: 10px;" [nzOptions]="UploadModeOptions" (nzValueChange)="handleIndexChange($event)"></nz-segmented>

<app-mit-dialog *ngIf="dialogFields" [formGroup]="formGroup" [dialogFields]="dialogFields" [callback]="callback" [enablePreUpload]="false"></app-mit-dialog>